import React from "react";
import styled from "styled-components";
import { WMKLink } from "wmk-lib";
import PropTypes from "prop-types";
import Theme from "../../vars/ThemeOptions";

const Styled = {};
Styled.Button = styled(WMKLink)`
  text-align: center;
  padding: 0.5rem 2rem;
  transition: all 0.45s ease;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
  background: ${Theme.hex("blue")};
  color: ${Theme.hex("white")};
  &.white {
    background: ${Theme.hex("white")};
    color: ${Theme.hex("blue")};
  }
  :hover {
    text-decoration: none;
    color: ${Theme.hex("white")};
    box-shadow: 3px 4px 10px rgba(0, 0, 0, 0.35);
    transition: all 0.45s ease;
    background: ${Theme.hex("green")};
  }
`;

export const Button = ({ children, white, className, to, target }) => {
  const _classname = white ? ["white"] : ["black"];
  _classname.push("thr-button");
  _classname.push(className);
  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <Styled.Button
        className={_classname.join(" ")}
        to={to}
        target={target && (target !== '_self' && target !== 'self') ? target : undefined}
      >
        {children}
      </Styled.Button>
    </div>
  );
};

Button.defaultProps = {
  white: false,
  className: "",
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  white: PropTypes.bool,
  className: PropTypes.string,
};
